import { faker } from '@faker-js/faker'

import { AdminTreatmentTag } from '../../contracts/treatment/AdminTreatmentTag'
import { asBuilder } from '../asBuilder'

export const getAdminTreatmentTags = asBuilder<AdminTreatmentTag>((): AdminTreatmentTag => {
  return {
    id: faker.number.int(),
    name: faker.string.uuid(),
    label: faker.string.uuid(),
    tagMeta: {
      name: faker.string.uuid(),
      nameKr: faker.string.uuid(),
    },
  }
})
